import React from 'react';
import { array, func, object, string, number } from 'prop-types';
import { matchPath } from 'react-router';
import { List } from '@material-ui/core';
import { withPermissionsChecker } from 'wrappers';
import NavItem from './NavItem';

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items
        .map(item => buildNavItem({ item, ...rest }))
        .filter(Boolean)}
    </List>
  )
}

function buildNavItem({
  item,
  pathname,
  depth = 0,
  modulo = item.title,
  checkAccess,
  checkHasAny,
}) {
  const enabled = item.enabled !== undefined ? item.enabled : true;
  if (!enabled) return null;

  if (item.permission && !checkHasAny(item.permission)) return null;

  const key = `${modulo}-${item.title}`;

  if (item.items?.length) {
    const open = matchPath(pathname, { path: item.href, exact: false });

    return (
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
        modulo={modulo}
      >
        {renderNavItems({ depth: depth + 1, pathname, items: item.items, modulo, checkAccess, checkHasAny })}
      </NavItem>
    );
  }

  if (item.permission && !checkAccess(item.permission)) return null;

  return (
    <NavItem
      depth={depth}
      href={item.href}
      icon={item.icon}
      key={key}
      info={item.info}
      title={item.title}
      path={item.path}
    />
  );
}

renderNavItems.propTypes = {
  items: array.isRequired,
  checkAccess: func,
};

buildNavItem.propTypes = {
  item: object,
  modulo: string,
  pathname: string,
  depth: number,
  checkAccess: func,
  checkHasAny: func,
};

export default withPermissionsChecker(renderNavItems);
